import { useMutation, useQueryClient } from '@tanstack/react-query';
import FileDownload from 'js-file-download';

import { downloadCustomerDocuments } from '../../common/api/clients/supplierOnboarding.api';
import { queries } from '../../common/api/queryKeys/queries';
import { extractFileName } from '../../common/helpers/extractFileName.helper';
import { translate } from '../../common/helpers/translate.helper';

interface DownloadCustomerOnboardingDocumentsVariables {
    offerId: string;
}

export const useDownloadCustomerOnboardingDocuments = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ offerId }: DownloadCustomerOnboardingDocumentsVariables) => downloadCustomerDocuments(offerId),
        onSuccess: (response) => {
            FileDownload(
                response.data,
                extractFileName(
                    response.headers['content-disposition'] || '',
                    translate('attachments.fileNameFallback')
                )
            );

            // The first supplier download moves the request to IN_PROGRESS, so refresh it.
            queryClient.invalidateQueries({
                queryKey: queries.supplierOnboarding._def,
            });
        },
    });
};
